import { useEffect, useState } from 'react';
import { Drawer } from 'antd';
import styled from 'styled-components';
import CloseAlerts from 'Components/alerts/assets/svg/CloseAlerts';
import {
  maxWidth,
  primaryColor,
  primaryFont,
  primaryHeadingColor,
  retina,
  scrollbar, secondaryFont, wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';

const Wrapper = styled.div`
  height: 32px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    height: 30px;
  }
  position: absolute;
  right: 0;
  bottom: -2px;
  background: #fff;
  padding-right: 10px;
`;

const ScrollWrapper = styled.div`
  margin: 0px 10px 0 20px;
  padding: 10px 8px 10px 10px;
  height: calc(100vh - 180px);
  ${scrollbar};
  @media all and (max-width: ${maxWidth}), ${retina} {
    height: calc(100vh - 185px);
  }
`;

const Heading = styled.h3`
  font-family: ${secondaryFont};
  font-size: 46px;
  line-height: 44px;
  color: ${primaryHeadingColor};
  font-weight: ${wMedium};
  margin-bottom: 0px;
  padding: 0px 30px;
  &.mb-head {
    margin-bottom: 30px;
  }
`;

const BrowseAll = styled.span`
`;

const LearnMore = styled.span`
  font-size: 16px;
  font-weight: ${wMedium};
  font-family: ${primaryFont};
  line-height: 36px;
  letter-spacing: -0.35px;
  color: ${primaryColor};
  cursor: pointer;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 14px;  
  }
`;

const Description = styled.p`
  margin: 0px;
  color: #7E7E7E;
  font-weight: 400;
  font-family: ${primaryFont};
  font-size: 16px;
  white-space: pre-wrap;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 14px;
  }
`;

type Props = {
  title?: string,
  titleOne?: string,
  desc?: string,
} & typeof defaultProps;

const defaultProps = {
  title: '',
  titleOne: '',
  desc: '',
};

const DrawerCompanyDetails = function DrawerCompanyDetails(props: Props) {
  const [visible, setVisible] = useState(false);
  const { title, titleOne, desc } = props;
  const toggle = () => {
    setVisible(!visible);
  };
  useEffect(() => {
    const node = document.querySelector('body');
    return visible ? node?.classList.add('body-drawer-toggle') : node?.classList.remove('body-drawer-toggle');
  }, [visible]);
  return (
    <Wrapper>
      <BrowseAll onClick={toggle} className={classNames({ drawerBoxOpen: visible })}>
        <LearnMore>
          ...more
        </LearnMore>
      </BrowseAll>
      <Drawer
        rootClassName="drawer-alerts people-group-drawer"
        placement="right"
        open={visible}
        onClose={toggle}
        width={530}
        extra={(
          <span onClick={toggle} onKeyPress={toggle} tabIndex={0} role="button" aria-label="close" className="close-alerts"><CloseAlerts /></span>
        )}
      >

        {titleOne && <Heading>{titleOne}</Heading>}
        <Heading className="mb-head">{title}</Heading>
        <ScrollWrapper>
          <Description>{desc}</Description>
        </ScrollWrapper>
      </Drawer>
    </Wrapper>
  );
};

DrawerCompanyDetails.defaultProps = defaultProps;
export default DrawerCompanyDetails;
